var _defs, _sodipodiNamedview;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAioWhiteTest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: 48,
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 325 155",
    xmlSpace: "preserve",
    sodipodiDocname: "file.svg",
    height: 48,
    inkscapeVersion: "1.3.2 (091e20e, 2023-11-25, custom)",
    "inkscapeExport-filename": "..\\\\\\\\Documents\\\\\\\\MONASH\\\\\\\\MAPS\\\\\\\\website svg\\\\\\\\aio_gradient.svg",
    "inkscapeExport-xdpi": 96,
    "inkscapeExport-ydpi": 96,
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs13"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview13",
    pagecolor: "#352ff3",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1",
    showguides: "false",
    inkscapeZoom: 64,
    inkscapeCx: 8.484375,
    inkscapeCy: 20.726562,
    "inkscapeWindow-width": 1920,
    "inkscapeWindow-height": 1094,
    "inkscapeWindow-x": -11,
    "inkscapeWindow-y": -11,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "g13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E73C2C",
    opacity: 1,
    stroke: "none",
    d: "m 25.088293,24.978362 c -0.43974,-4.307425 2.327196,-8.203072 6.449215,-9.080033 5.155565,-1.096847 9.766797,2.344826 10.205809,7.67411 -0.405467,-1.036348 -1.427372,-1.523414 -2.383532,-1.027786 -0.378268,0.196077 -0.671577,0.556055 -1.031229,0.795496 -0.624791,-3.354839 -3.927844,-4.950887 -6.639906,-3.916971 -2.065195,0.787309 -3.137001,2.474103 -3.25404,5.136375 -0.228892,1.59544 -2.248156,1.723668 -2.978184,0.59661 -0.07176,-0.110782 -0.244413,-0.119733 -0.368133,-0.177801 z",
    id: "path2",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.143131
    },
    sodipodiNodetypes: "cscscscsc"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d70a26",
    opacity: 1,
    stroke: "none",
    d: "m 25.088705,24.977806 c 0.125544,-0.0045 0.305971,-0.07869 0.406783,0.0065 1.216164,1.027621 2.128674,0.959464 2.939703,-0.425387 0.68245,3.624272 4.323183,5.513637 7.404017,3.750787 1.883217,-1.077572 2.60618,-2.8544 2.494642,-4.981776 0.331994,-0.28535 0.639855,-0.743432 1.018123,-0.939509 0.95616,-0.495628 1.993705,0.0873 2.390877,1.182877 0.406703,4.032886 -2.896931,8.070877 -6.941032,8.725423 -4.688239,0.758803 -9.161207,-2.631905 -9.713113,-7.318897 z",
    id: "path3",
    sodipodiNodetypes: "cccscscsc",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.143131
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e73c2c",
    opacity: 1,
    stroke: "none",
    d: "m 7.0228301,28.692098 c -0.464551,0.906341 -0.916244,1.819564 -1.39683,2.717324 -0.63351,1.183425 -2.1019818,1.369917 -2.9025803,0.363821 -0.5236405,-0.658049 -0.4088502,-1.394273 -0.08341,-2.081911 1.5164707,-3.204165 3.0558703,-6.39748 4.5871302,-9.594646 0.49324,-1.029851 1.0146061,-2.047422 1.4709571,-3.093363 0.350293,-0.802861 0.836845,-1.421731 1.7645999,-1.433961 0.948181,-0.0125 1.434819,0.657796 1.78139,1.513535 -0.895909,2.17729 -1.727011,4.106742 -2.6776909,6.120246 -0.3309941,0.714549 -0.6142985,1.44757 -0.9682795,2.196601 0.36405,0.74509 -0.7866334,2.165936 -1.3708934,3.226063 z",
    id: "path4",
    sodipodiNodetypes: "csssssscsccc",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.143131
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e73d2d",
    opacity: 1,
    stroke: "none",
    d: "m 23.609519,17.084719 c 0.01641,0.592623 0.04686,1.185242 0.04697,1.777869 7.17e-4,3.993401 -0.005,7.986803 -0.04916,12.055589 0.0016,0.07534 -0.003,0.115925 -0.01058,0.190459 -0.355852,0.94372 -1.087113,1.426072 -1.949292,1.28578 -0.812656,-0.132232 -1.433765,-0.860575 -1.436684,-1.794248 -0.01362,-4.358259 -0.01306,-8.716605 -5.73e-4,-13.074872 0.0028,-0.968334 0.547693,-1.633922 1.399859,-1.822281 0.810036,-0.179045 1.484164,0.214231 1.957174,1.215156 0.0302,0.07244 0.03225,0.109393 0.04225,0.166548 z",
    id: "path5",
    sodipodiNodetypes: "csccsssscc",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.143131
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ec634a",
    opacity: 1,
    stroke: "none",
    d: "m 7.020341,28.698733 c 0.526773,-1.022545 0.989244,-2.064541 1.5871721,-3.33334 1.302904,-0.02416 2.7088749,-0.0625 3.9477629,-0.08875 1.358783,-0.04644 2.532917,-0.35628 3.778614,0.344497 0.227824,0.475237 0.419003,0.774577 0.641868,1.327541 -0.06809,1.000091 -0.777924,1.877414 -2.233639,1.759982 -2.479588,0.159786 -5.177692,0.0068 -7.7217779,-0.01 z",
    id: "path6",
    sodipodiNodetypes: "cccccscc",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.143131
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d70a26",
    opacity: 1,
    stroke: "none",
    d: "M 16.342794,25.632779 C 15.091857,24.986322 13.783146,25.316563 12.410821,25.27836 11.78258,23.968453 11.083171,22.475107 10.49128,21.182618 9.393438,19.038652 10.778117,16.72578 12.242329,17.08328 c 1.389376,2.789471 2.753323,5.666745 4.100465,8.549499 z",
    id: "path7",
    sodipodiNodetypes: "ccccc",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.143131
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e73d2d",
    opacity: 1,
    stroke: "none",
    d: "m 44.360953,32.284053 c -1.322384,0.429257 -2.519207,-0.103043 -2.89816,-1.336436 -0.345984,-1.126068 0.297333,-2.26557 1.476164,-2.614735 0.985482,-0.291895 2.078316,0.214105 2.491457,1.153587 0.474428,1.078851 0.136197,2.132194 -1.069461,2.797584 z",
    id: "path8",
    sodipodiNodetypes: "csssc",
    style: {
      fill: "#f2f2f2",
      fillOpacity: 1,
      strokeWidth: 0.143131
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d70a26",
    opacity: 1,
    stroke: "none",
    d: "m 14.113767,28.741341 c 0.209185,-0.01619 0.499289,-0.545875 0.782849,-0.548455 1.409073,0.0656 1.414594,-1.168454 2.079236,-1.241936 0.504247,0.93209 0.988536,1.933033 1.432667,2.902299 0.455055,0.993103 0.113444,1.980277 -0.801609,2.410273 -0.865134,0.406544 -1.816878,0.02893 -2.302276,-0.937892 -0.393215,-0.783217 -0.803066,-1.743443 -1.190867,-2.584283 z",
    id: "path9",
    sodipodiNodetypes: "cccssscc",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.143131
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioWhiteTest);
export default __webpack_public_path__ + "static/media/aio_white_test.2f3a0457e44b7095e4372fb3f6a7bd00.svg";
export { ForwardRef as ReactComponent };